import { HlsConfig } from 'hls.js';
import { HlsJsPreset } from '../../types';

const baseConfig: Partial<HlsConfig> = {
  enableWorker: true, // keep main thread snappy
};

/**
 * VOD (Video On Demand) preset for HLS.js
 * Optimized for playback of pre-recorded content with progressive loading
 */
export const vodPreset: HlsJsPreset = {
  config: {
    ...baseConfig,

    // 1. DISABLE ALL LIVE LOGIC
    // This ensures the player never tries to 'snap' to the end.
    lowLatencyMode: false,

    // 2. SPEED & STARTUP
    autoStartLoad: true,
    startFragPrefetch: true,
    progressive: true, // Start playing the 30s segment before it fully downloads
  },
};
